/**
 * ION SDK error codes.
 */
export default {
  DeltaExceedsMaximumSize: 'DeltaExceedsMaximumSize',
  DidDocumentPublicKeyIdDuplicated: 'DidDocumentPublicKeyIdDuplicated',
  DidDocumentPublicKeyMissingOrIncorrectType: 'DidDocumentPublicKeyMissingOrIncorrectType',
  DidDocumentServiceIdDuplicated: 'DidDocumentServiceIdDuplicated',
  DidSuffixIncorrectLength: 'DidSuffixIncorrectLength',
  EncodedStringIncorrectEncoding: 'EncodedStringIncorrectEncoding',
  IdNotUsingBase64UrlCharacterSet: 'IdNotUsingBase64UrlCharacterSet',
  IdTooLong: 'IdTooLong',
  JwkEs256kMissingOrInvalidCrv: 'JwkEs256kMissingOrInvalidCrv',
  JwkEs256kMissingOrInvalidKty: 'JwkEs256kMissingOrInvalidKty',
  JwkEs256kHasIncorrectLengthOfX: 'JwkEs256kHasIncorrectLengthOfX',
  JwkEs256kHasIncorrectLengthOfY: 'JwkEs256kHasIncorrectLengthOfY',
  JwkEs256kHasIncorrectLengthOfD: 'JwkEs256kHasIncorrectLengthOfD',
  MultihashStringNotAMultihash: 'MultihashStringNotAMultihash',
  MultihashUnsupportedHashAlgorithm: 'MultihashUnsupportedHashAlgorithm',
  PublicKeyJwkEs256kHasUnexpectedProperty: 'PublicKeyJwkEs256kHasUnexpectedProperty',
  PublicKeyPurposeDuplicated: 'PublicKeyPurposeDuplicated',
  ServiceEndpointCannotBeAnArray: 'ServiceEndpointCannotBeAnArray',
  ServiceEndpointStringNotValidUri: 'ServiceEndpointStringNotValidUri',
  ServiceTypeTooLong: 'ServiceTypeTooLong'
};
